<template>
  <transition name="fade">
    <div class="create-posts">
      <div class="posts-container">
        <div class="close-icon" @click="$emit('close-upload-pop')">
          <Icon type="md-close"></Icon>
        </div>
        <div class="content-container">
          <div class="tabs-container">
            <div
              class="tabs-item"
              :class="[type == 2 ? 'active' : '']"
              @click="onChangeTab(2)"
            >
            Upload Video
            </div>
            <div
              class="tabs-item"
              :class="[type == 1 ? 'active' : '']"
              @click="onChangeTab(1)"
            >
            Upload Images
            </div>
          </div>

          <Upload
            type="drag"
            :action="upload_url"
            :data="{ dir: 'template' }"
            :multiple="type == 1"
            :before-upload="onBeforeUpload"
            :on-success="
              (response, file, fileList) =>
                handleSuccess(
                  response,
                  file,
                  fileList,
                  type == 1 ? 'img_list' : 'video'
                )
            "
            :show-upload-list="false"
            :format="type == 1 ? format_img : format_video"
            :accept="type == 1 ? accept_img : accept_video"
          >
            <template>
              <div class="upload-container">
                <div class="upload-content">
                  <!-- <Spin fix v-if="uploading">
                    <Icon
                      type="ios-loading"
                      size="40"
                      class="spin-icon-load"
                    ></Icon>
                    <div>Uploading</div>
                  </Spin> -->
                  <img
                    src="../assets/images/icon-create-upload.png"
                    alt=""
                    class="up-icon"
                  />
                  <div class="up-text">
                    Drag and drop {{ type == 2 ? "video" : "images" }} here or click to upload
                  </div>
                  <div class="up-img-tip" v-if="type == 1">
                    (Supports up to 18 images per upload)
                  </div>
                  <Button class="up-btn"
                    > Upload {{ type == 2 ? "Video" : "Images" }}</Button
                  >
                </div>
              </div>
              <video style="display: none" ref="video" muted></video>
              <canvas style="display: none" ref="canvas"></canvas>
            </template>
          </Upload>

          <div class="bottom-container" v-if="type == 2">
            <div class="bottom-items">
              <div class="title-line">Video Size</div>
              <div class="text-line">Supports videos up to 60 minutes</div>
              <div class="text-line"> Maximum video file size of 20GB</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">Video Format</div>
              <div class="text-line">Supports common video formats</div>
              <div class="text-line">Recommended MP4, MOV</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">Video Resolution</div>
              <div class="text-line"> Recommended to upload 720P (1280720) or higher videos</div>
              <div class="text-line">Videos over 1080P will have clearer quality when uploaded via web</div>
            </div>
          </div>
          <div class="bottom-container" v-else>
            <div class="bottom-items">
              <div class="title-line">Image Size</div>
              <div class="text-line">Supported image upload size</div>
              <div class="text-line">Maximum image file size of 32MB</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">Image Format</div>
              <div class="text-line">Supported image formats, recommended</div>
              <div class="text-line">PNG, JPG, JPEG, WEBP, GIF not supported,</div>
              <div class="text-line">LIVE and converted images</div>
            </div>
            <div class="bottom-items">
              <div class="title-line">Image Resolution</div>
              <div class="text-line">No restriction on aspect ratio, recommended to upload between 3:4 to 2:1</div>
              <div class="text-line">Photos with resolution no less than 720*960</div>
              <div class="text-line">Images over 1280P will have clearer quality when uploaded via web</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import videoMixin from "@/mixins/video.js";
import { CreatePosts } from "@/api/social";
import { uploadFileToOSS } from "@/utils/oss";
export default {
  name: "CreatePosts",
  data() {
    return {
      type: 1,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      format_img: ["jpg", "jpeg", "png", "gif",'webp'],
      format_video: ["mp4", "mov"],
      accept_img: ".jpg,.jpeg,.png,.gif,.webp",
      accept_video: ".mp4,.mov",
      image_list: [],
      video_url: "",
      uploading: false,
      uploadQueue:[],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
    };
  },
  mixins: [videoMixin],
  props: {
    incomeType: {
      type: Number,
      default: 1,
    },
  },
  mounted() {
    if (this.incomeType) {
      this.type = this.incomeType;
    }
  },
  methods: {
    onChangeTab(type) {
      this.type = type;
    },
    async onPostsCreate() {
      try {
        const { type, image_list, video_url, video_info } = this;
        const { file_size, duration, cover, name } = video_info;
        const param = {};
        param.type = type;
        param.image_list = image_list;
        param.video = video_url;
        param.media_info = { file_size, duration, name };
        param.cover = cover;
        param.status = -1;
        const { data } = await CreatePosts(param);
        console.log("data", data);
        this.$router.push({ name: "Posts", params: { uuid: data.uuid } });
      } catch (e) {
        this.$layer.msg("上传失败");
      } finally {
        this.$emit("close-upload-pop");
      }
    },
    async processAllFiles() {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`开始上传 ${queue.length} 个文件`);

      for (const file of queue) {
        try {
          const url = await uploadFileToOSS(file, "template");

          if (this.type === 1) {
            this.image_list.push(url);
            if (this.image_list.length >= 18) {
              this.$layer.msg("最多上传18张图片");
            }
          } else {
            this.video_url = url;
          }
        } catch (err) {
          this.$layer.msg(`上传失败：${file.name}`);
        }
      }

      // 所有文件上传完成后执行一次提交逻辑
      this.onPostsCreate();
    },
    onBeforeUpload(file) {
      console.log("file-before", file);
      this.uploading = true;
      if (this.type == 2) {
        this.video_info.name = file.name;
        this.onVideoExcute(file);
      }
       // 将文件加入队列
       this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
        this.processAllFiles();
      }, this.debounceTime);
      return false;
    },
    handleSuccess(response, file, fileList, field) {
      const length = this.image_list.length;
      if (length >= 18) {
        this.$layer.msg("最多上传16张图片");
        return;
      }
      console.log("file", file);
      if (field === "img_list") {
        this.image_list.push(response.data.url);
      } else {
        console.log("video__info", this.video_info);
        this.video_url = response.data.url;
        this.uploading = false;
        //TODO 发起数据提交
        this.onPostsCreate();
      }

      if (fileList.length === this.image_list.length) {
        this.uploading = false;
        //TODO 发起数据提交
        this.onPostsCreate();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.create-posts {
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .posts-container {
    // width:930px;
    // height:650px;
    border-radius: 10px;
    background: white;
    position: relative;
    .close-icon {
      position: absolute;
      top: 20px;
      right: 25px;
      cursor: pointer;
    }
    .content-container {
      padding: 40px 30px;
      .tabs-container {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 25px;
        .tabs-item {
          font-size: 18px;
          color: #000000;
          padding-bottom: 10px;
          margin-right: 45px;
          cursor: pointer;
          &.active {
            color: #ff5e52;
            border-bottom: 3px solid #ff5e52;
          }
        }
      }
      .upload-container {
        width: 871px;
        height: 421px;
        border: 1px dashed #dbdbdb;
        background: #f7f7f7;
        display: flex;
        justify-content: center;
        .upload-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .up-icon {
            width: 100px;
            height: 65px;
          }
          .up-text {
            font-size: 14px;
            color: #333333;
            margin-top: 30px;
          }
          .up-img-tip {
            font-size: 12px;
            color: #666666;
            margin-bottom: 30px;
          }
          .up-btn {
            background: #fe5866;
            border-radius: 5px;
            color: #ffffff;
          }
        }
      }
      .bottom-container {
        margin-top: 25px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .bottom-items {
          flex: 0 0 33.33%;
          text-align: center;
          &:nth-child(2) {
            border-left: 1px solid #f0f0f0;
            border-right: 1px solid #f0f0f0;
          }
          .title-line {
            font-size: 14px;
            color: #1a1a1a;
            margin-bottom: 10px;
          }
          .text-line {
            font-size: 12px;
            color: #666666;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
